import {action, observable, runInAction} from "mobx";
import type {ITooltipOptions, ITooltipService} from "./tooltip.service.interface";
import {ServiceBase} from "../ServiceBase";
import {IOverlayConsumer} from "../overlay/overlay-consumer.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {TooltipModel} from "./tooltip.model";

export class TooltipService extends ServiceBase implements ITooltipService, IOverlayConsumer {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        services.overlay.registerConsumer(this);
    }

    @observable.ref
    tooltipContainer: HTMLElement;

    @observable
    tooltipsQueue: TooltipModel[] = [];

    get currentTooltip(): TooltipModel | null {
        if(this.tooltipsQueue.length === 0) {
            return null;
        }

        return this.tooltipsQueue[0];
    }

    removeTooltip(tooltip: TooltipModel): void {
        const index = this.tooltipsQueue.findIndex(t => t.id === tooltip.id);
        if(index >= 0) {
            runInAction(() => {
                this.tooltipsQueue.splice(index, 1);
            });
        }
    }
    /*
        _subscribe() {

            //On screen resize, destroy and recreate current tooltip
            this.services.window.subscribeTo.resize(() => {
                if (this.currentToolTip) {
                    this.currentToolTip.show();
                }
            });
    }*/

    onOverlayClicked() {
        //nothing to do here
    }

    getOverlayZIndex(): number | undefined {
        if(!this.currentTooltip) {
            return undefined;
        }

        return this.currentTooltip.zIndex - 1;
    }

    get needsOverlay(): boolean {
        return Boolean(this.currentTooltip?.showOverlay);
    }


    @action.bound
    setTooltipContainer(element: HTMLElement) {
        this.tooltipContainer = element;
    }

    @action.bound
    createTooltip(options: ITooltipOptions): TooltipModel {
        options = {
            showOverlay: true,
            showCloseButton: false,
            closeOnClickOutside: true,
            animated: true,
            ...options};

        const tooltipModel = new TooltipModel(this, this.services, options);

        this.tooltipsQueue.push(tooltipModel);

        return tooltipModel;

    }
}